import { configureStore } from '@reduxjs/toolkit';

import { rtkQueryErrorLogger } from 'middlewares/error.middleware';

import authorization from 'store/authorization';
import clientPortalChats from 'store/clientPortalChats';
import common from 'store/common';
import configuration from 'store/configuration';
import connectwise from 'store/connectwise';
import microsoft from 'store/microsoft';
import pod from 'store/pod';
import pricePlan from 'store/pricePlan';
import secureDataSharing from 'store/secureDataSharing';
import smsConversations from 'store/smsConversations';
import whatsAppMessaging from 'store/whatsAppMessaging';
import table from 'store/table';
import teamsChat from 'store/teamsChat';
import templates from 'store/templates';
import user from 'store/user';
import verificationSettings from 'store/verificationSettings';

export const store = configureStore({
  reducer: {
    configuration,
    user,
    authorization,
    common,
    verificationSettings,
    pod,
    clientPortalChats,
    smsConversations,
    whatsAppMessaging,
    secureDataSharing,
    table,
    pricePlan,
    connectwise,
    templates,
    teamsChat,
    microsoft,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
